import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../toolkit/uicomponentcss';

export interface CRBTUICSSStyle extends UIComponentCSSStyle
{
    getInnerCSSStyle(): object;
}

export class CRBTUICSSStyleImpl extends UIComponentCSSStyleImpl implements CRBTUICSSStyle
{     
    getInnerCSSStyle(): object 
    {
        return {
            // height: '100%', changed
            width: '100%', 
            position:'relative',
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/crbt/crbtuicss.tsx